<template>
    <v-container class="fill-height" style="display: block;" fluid>


        <v-row>
            <v-col cols="12" lg="4" class="d-flex flex-column" style="height: calc(100vh - 84px);">
                <v-card>
                    <v-card-title>Network Discovery Settings</v-card-title>
                    <v-chip class="run-state-text" small pill :text-color="runState.textColor" :color="runState.color">
                        {{ runState.text }} <v-icon class="ml-1" color="#ffffff" style="font-size: 12px;" v-if="runState.text == 'Running'">fas fa-spinner fa-spin</v-icon>
                    </v-chip>

                    <v-divider />
                    <v-card-text>
                        <v-row class="mt-3 mb-1" dense>
                            <v-col md="12">
                                <v-text-field dense disabled color="#c42111" v-model="$props.networkDiscoveryRequest.network" label="Network" hint="Ex: 10.0.0.0/24" persistent-hint />
                            </v-col>
                            <!-- <v-col md="6">
                                <v-text-field dense disabled color="#c42111" v-model="$props.networkDiscoveryRequest.scan_options.maxHops" label="Max Network Hops" type="number" />
                            </v-col> -->

                            <v-col cols="12"><v-divider class="mt-2 mb-4" /></v-col>

                            <v-col md="6">
                                <v-checkbox dense disabled color="#c42111" v-model="$props.networkDiscoveryRequest.scan_options.enablePing" label="Enable Ping" />
                            </v-col>
                            <v-col md="6">
                                <v-text-field dense disabled color="#c42111" v-model="$props.networkDiscoveryRequest.scan_options.pingTimeoutSec" label="Ping Timeout Sec" type="number" />
                            </v-col>

                            <v-col cols="12"><v-divider class="mt-2 mb-4" /></v-col>

                            <v-col md="6">
                                <v-checkbox dense disabled color="#c42111" v-model="$props.networkDiscoveryRequest.scan_options.enableSnmp" label="Enable SNMP Scan" />
                            </v-col>
                            <v-col md="6">
                                <v-text-field dense disabled color="#c42111" v-model="$props.networkDiscoveryRequest.scan_options.snmpTimeoutSec" label="SNMP Timeout Sec" type="number" />
                            </v-col>
                            <v-col md="6">
                                <v-text-field dense disabled color="#c42111" v-model="$props.networkDiscoveryRequest.scan_options.snmpCommunityString" label="SNMP Community String" />
                            </v-col>
                            <v-col md="6">
                                <v-autocomplete dense disabled autocomplete="off" v-model="$props.networkDiscoveryRequest.scan_options.pm_groups" multiple :items="$props.pmSnmpOptions"  color="#c42111" label="PM Groups" />
                            </v-col>

                            <v-col cols="12"><v-divider class="mt-2 mb-4" /></v-col>

                            <v-col md="6">
                                <v-checkbox dense disabled color="#c42111" v-model="$props.networkDiscoveryRequest.scheduleRun" label="Schedule Network Discovery to Run in the Future" />
                            </v-col>
                            <v-col md="6">
                                <v-datetime-picker dense disabled label="Scheduled Run Time" v-model="$props.networkDiscoveryRequest.scheduled_at" :timeFormat="'HH:mm:ss'" :textFieldProps="tfProps" :datePickerProps="dpProps" :timePickerProps="tpProps" v-if="$props.networkDiscoveryRequest.scheduleRun"></v-datetime-picker>
                            </v-col>
                        </v-row>
                    </v-card-text>
                    <v-divider />
                    <v-card-actions>
                        <v-btn text @click="$emit('back')"><v-icon>mdi mdi-menu-left</v-icon>Back</v-btn>
                    </v-card-actions>
                </v-card>

                
                <div class="messages-section">
                    <div class="messages-container-label">Discovery Events</div>
                    <div class="messages-container">
                        <p style="white-space: pre-line;">{{ $props.networkDiscoveryRequest.run_notes }}</p>
                    </div>
                </div>
                
            </v-col>

            <v-col cols="12" lg="8">
                <div id="ag-grid-container">
                    <ag-grid-vue style="width: 100%; height: 100%;" class="ag-theme-balham" v-if="showGrid"
                        :gridOptions="gridOptions"
                        :groupHeaders="true"
                        :rowSelection="'multiple'"
                        :rowHeight="40">
                    </ag-grid-vue>
                </div>

                <v-btn class="mt-2 mr-2" color="#c42111" :disabled="!$props.networkDiscoveryRequest.scan_options.enablePing" @click="$emit('addDevicesClick', 'ping', gridApi.getSelectedRows())">Add Ping Targets</v-btn>
                <v-btn class="mt-2" color="#c42111" :disabled="!$props.networkDiscoveryRequest.scan_options.enableSnmp" @click="$emit('addDevicesClick', 'snmp', gridApi.getSelectedRows())">Add SNMP Devices</v-btn>
            </v-col>

        </v-row>

    </v-container>
</template>

<script>
import { AgGridVue } from "ag-grid-vue";
import "@/../node_modules/ag-grid-community/dist/styles/ag-grid.css";
import "@/../node_modules/ag-grid-community/dist/styles/ag-theme-balham.css";
export default {
    name: 'NetworkDiscoveryResults',
    props: ['networkDiscoveryRequest', 'existingDevices', 'pmSnmpOptions', 'refresh'],
    components: {
        'ag-grid-vue': AgGridVue,
    },
    data: () => ({
        showGrid: false,
        gridOptions: null,
        gridApi: null,
        resultsHash: null,
        snmpStandardCols: ['ifmib', 'sysName', 'ifNumber', 'sysDescr', 'sysObject', 'sysUpTime', 'sysContact', 'ipAdEntAddr', 'sysLocation', 'host_up_time', 'cisco_process']
    }),

    computed: {
        runState() {
            if(this.$props.networkDiscoveryRequest.started_at && this.$props.networkDiscoveryRequest.running && !this.$props.networkDiscoveryRequest.completed_at) {
                return {color: 'primary', textColor: '#ffffff', text: `Running`};
            }
            else if(this.$props.networkDiscoveryRequest.started_at && !this.$props.networkDiscoveryRequest.running && this.$props.networkDiscoveryRequest.completed_at) {
                return {color: '#00E676', textColor: '#000000', text: `Completed At ${this.$props.networkDiscoveryRequest.completed_at}`};
            }
            else if(this.$props.networkDiscoveryRequest.started_at && !this.$props.networkDiscoveryRequest.running && this.$props.networkDiscoveryRequest.result_text.startsWith('ERROR')) {
                return {color: '#ff5252', textColor: '#000000', text: `Error Occured`};
            }
        }
    },

    methods: {
        buildAgGrid: function() {
            this.showGrid = false;
            this.gridOptions = {};
            this.gridOptions.rowData = this.$props.networkDiscoveryRequest.results;
            this.gridOptions.columnDefs = this.createColumnDefs();
            let self = this;
            this.gridOptions.onGridReady = function(params) {
                self.gridApi = self.gridOptions.api;
                self.gridOptions.api.hideOverlay();
                self.gridOptions.columnApi.autoSizeColumns();
                //self.gridOptions.api.sizeColumnsToFit();
            }

            this.gridOptions.getContextMenuItems = function() {
                return [
                    'copy',
                    'copyWithHeaders',
                    'paste',
                    'csvExport',
                    'excelExport',
                    {
                        name: 'AI Analyser',
                        disabled: !self.$store.state.batchConfig.webapp_openai,
                        action: function() {
                            self.$store.commit('setAiAnalyzerContext', 'pingTargets');
                            self.$store.commit('setAiAnalyzerGridAPI', self.gridOptions.api);
                            self.$store.commit('setShowAIAnalyzer', true);
                        },
                        icon: `<i data-v-10101010101="" aria-hidden="true" class="v-icon notranslate mdi mdi-lightning-bolt theme--dark"></i>`
                    },
                ];
            };

            this.gridOptions.defaultColDef = {
                sortable: true,
                filter: true,
                resizable: true
            }
            this.showGrid = true;
        },

        createColumnDefs: function() {
            let columnDefs = [];
            const self = this;
            columnDefs = [
                {
                    headerName: 'Add',
                    headerCheckboxSelection: true, // Checkbox in the header for selecting all rows
                    checkboxSelection: true,       // Enable checkbox for individual rows
                    width: 90
                },
                { 
                    headerName: 'IP', 
                    width: 150, filter: 'text', cellStyle: {'padding-top': '8px', 'text-align': 'left'},
                    field: 'ip_address'
                },
                { 
                    headerName: 'MAC', 
                    width: 150, filter: 'text', cellStyle: {'padding-top': '8px', 'text-align': 'left'},
                    field: 'mac_address'
                },
                { 
                    headerName: 'Host Name', 
                    width: 150, filter: 'text', cellStyle: {'padding-top': '8px', 'text-align': 'left'},
                    field: 'hostname'
                },
                { 
                    headerName: 'Responded to Ping', 
                    width: 150, filter: 'text', cellStyle: {'padding-top': '8px', 'text-align': 'left'},
                    field: 'ping_responded',
                    cellRenderer: function(params) {
                        if(params.data.ping_responded) {
                            return `<i data-v-52351983="" aria-hidden="true" class="v-icon notranslate mdi mdi-check theme--dark green--text"></i>`;
                        }
                        return `<i data-v-52351983="" aria-hidden="true" class="v-icon notranslate mdi mdi-close theme--dark red--text"></i>`;
                    }
                },
                { 
                    headerName: 'Already in Ping Targets', 
                    width: 150, filter: 'text', cellStyle: {'padding-top': '8px', 'text-align': 'left'},
                    field: 'existing_ping_target',
                    cellRenderer: function(params) {
                        let pingTarget = self.$props.existingDevices.existing_ping_targets.find(p => p.ping_addr == params.data.ip_address)
                        if(pingTarget) {
                            return pingTarget.ping_name;
                        }
                    }
                },
                { 
                    headerName: 'Already in SNMP Devices', 
                    width: 150, filter: 'text', cellStyle: {'padding-top': '8px', 'text-align': 'left'},
                    field: 'existing_snmp_device',
                    cellRenderer: function(params) {
                        let snmpDevice = self.$props.existingDevices.existing_snmp_devices.find(s => s.key == params.data.ip_address)
                        if(snmpDevice) {
                            return `${snmpDevice.key} - ${snmpDevice.comment || '""'}`;
                        }
                    }
                },
                { 
                    headerName: 'SNMP Data', 
                    width: 150, filter: 'text', cellStyle: {'padding-top': '8px', 'text-align': 'left'},
                    field: 'snmp_data',
                    cellRenderer: function(params) {
                        if(params.data.snmp_data) {
                            return `<i data-v-52351983="" aria-hidden="true" class="v-icon notranslate mdi mdi-check theme--dark green--text"></i>`;
                        }
                        if(!self.networkDiscoveryRequest.scan_options.enableSnmp) {
                            return 'Not Attempted';
                        }
                        if(self.networkDiscoveryRequest.running) {
                            if(params.data.snmp_data === false) {
                                return `<i data-v-52351983="" aria-hidden="true" class="v-icon notranslate mdi mdi-close theme--dark red--text"></i>`;
                            }
                            return '';
                        }
                        return `<i data-v-52351983="" aria-hidden="true" class="v-icon notranslate mdi mdi-close theme--dark red--text"></i>`;
                    }
                },
            ];

            if(self.$props.networkDiscoveryRequest.scan_options.enableSnmp) {
                for(let key of self.snmpStandardCols) {
                    columnDefs.push({
                        headerName: `SNMP: ${key}`, 
                        width: 150, filter: 'text', cellStyle: {'padding-top': '8px', 'text-align': 'left'},
                        field: `snmp:${key}`,
                        valueGetter: function(params) {
                            if(params.data.snmp_data && params.data.snmp_data[key]) {
                                return params.data.snmp_data[key];
                            }
                        }
                    });
                };

                // PM Group Cols
                for(let pmGroup of self.networkDiscoveryRequest.scan_options.pm_groups) {
                    let header = (this.$props.existingDevices.pm_groups_dict && this.$props.existingDevices.pm_groups_dict[pmGroup]) ? this.$props.existingDevices.pm_groups_dict[pmGroup] : pmGroup;
                    columnDefs.push({
                        headerName: `SNMP: ${header}`, 
                        width: 150, filter: 'text', cellStyle: {'padding-top': '8px', 'text-align': 'left'},
                        field: `snmp:${pmGroup}`,
                        cellRenderer: function(params) {
                            if(params.data.snmp_data && params.data.snmp_data[pmGroup]) {
                                return `<i data-v-52351983="" aria-hidden="true" class="v-icon notranslate mdi mdi-check theme--dark green--text"></i>`;
                            }
                            return `<i data-v-52351983="" aria-hidden="true" class="v-icon notranslate mdi mdi-close theme--dark red--text"></i>`;
                        }
                    });
                }
            }
            

            return columnDefs;
        },

    },

    watch: {
        networkDiscoveryRequest: {
            handler(newVal, oldVal) {
                if(newVal.request_id != oldVal.request_id) {
                    this.showGrid = false;
                    this.$nextTick(() => {
                        this.buildAgGrid();
                    });
                    return;
                }
                else if(TELSA.hash(newVal.results) != this.resultsHash) {
                    this.resultsHash = TELSA.hash(newVal.results);
                    if(this.showGrid) {
                        this.gridApi.setRowData(this.$props.networkDiscoveryRequest.results);
                    }
                    return;
                }
            },
            deep: true
        },

        refresh: {
            handler(newVal, oldVal) {
                this.showGrid = false;
                this.$nextTick(() => {
                    this.buildAgGrid();
                });
            }
        }
    },

    mounted() {
        this.buildAgGrid();
    }

  
};
</script>

<style scoped>

    .run-state-text {
        position: absolute;
        right: 16px;
        top: 20px;
    }

    #ag-grid-container {
        /* height: calc(100vh - 106px); */
        height: calc(100vh - 149px);
    }

    .messages-section {
        flex-grow: 1;
        position: relative;
        height: calc(100% - 112px);
        height: 0px;
    }

    .messages-container {
        border: 1px solid white;
        border-radius: 3px;
        margin-top: 15px;
        padding: 6px;
        overflow: auto;
        position: relative;
        height: calc(100% - 12px);
    }

    .messages-container-label {
        position: absolute;
        top: 3px;
        left: 24px;
        background-color: #303030;
        padding: 2px 5px 2px 5px;
        font-size: 13px;
        z-index: 9;
    }

</style>
